__turbopack_context__.v({
  "className": "foundersgroteskregular_e67e2396-module__LjBi_W__className",
});
